import { ApproverType } from '../types/approver-type';
import { ActionType } from '../types/action-type';
import { BodyField } from './body-field';
import { Form } from '../data/form';
import { OrgUnitType } from '../types/org-unit-type';
import { ApproverFormData } from '../custom-field-parameter/approver-form-data';

export class BodyForm {
  name: string | undefined;
  groupName: string | undefined;
  tag: string | undefined;
  visibleForGroups: string[] | undefined;
  owners: string[] | undefined;
  visible: boolean | undefined;
  operators: string[] | undefined;
  readers: string[] | undefined;
  tester: string[] | undefined;
  showLastOperator: boolean | undefined;
  allowCancelUntilProgressStarts: boolean | undefined;
  approverTypes: ApproverType[] | undefined;
  approverData: string | undefined;
  orderedApprovals: boolean | undefined;
  actionType: ActionType | null | undefined;
  actionData: string | undefined;
  fields: BodyField[] | undefined;
  orgUnitType: OrgUnitType | undefined;
  orgUnitName: string | undefined;
  privacyReason: string | undefined;
  dataFields: string | undefined;
  legalBasis: string | undefined;
  dataTransmission: string | undefined;
  externalDataTransmission: string | undefined;
  storagePeriod: number | undefined;
  contactEmail: string | undefined;
  contactTelephone: string | undefined;

  constructor(form: Form) {
    const tmpApproverDataArray: (ApproverFormData | null)[] = [];
    this.name = form.name?.trim();
    this.groupName = form.groupName;
    this.tag = form.tag?.trim();
    this.visibleForGroups = form.visibleForGroups;
    this.owners = form.owners;
    this.visible = form.visible;
    this.operators = form.operators;
    this.readers = form.readers;
    this.tester = form.tester;
    this.showLastOperator = form.showLastOperator;
    this.allowCancelUntilProgressStarts = form.allowCancelUntilProgressStarts;
    this.approverTypes = form.approverTypes ?? [];
    this.actionType = form.actionType;
    if (form.actionDataCustomParameter) {
      for (const [key, value] of Object.entries(form.actionDataCustomParameter)) {
        if (Array.isArray(value)) {
          // @ts-ignore
          form.actionDataCustomParameter[key] = value.filter(s => s).map(s => s.trim ? s.trim() : s);
        } else if (!value) {
          // @ts-ignore
          form.actionDataCustomParameter[key] = undefined;
        } else {
          // @ts-ignore
          form.actionDataCustomParameter[key] = value.trim ? value.trim() : value;
        }
      }
    }
    this.actionData = JSON.stringify(form.actionDataCustomParameter);
    this.fields = [];
    if (form.fields) {
      for (const field of form.fields) {
        this.fields.push(new BodyField(field));
      }
    }
    let i = 0;
    if (form.approverDataCustomParameter) {
      for (const userTmp of form.approverDataCustomParameter) {
        switch (this.approverTypes[i]) {
          case ApproverType.DESIGNATED_APPROVER:
            if (!userTmp?.users || userTmp.users.length === 0 || !userTmp.users[0] || typeof userTmp.users[0] === 'undefined') {
              tmpApproverDataArray.push(null);
            } else {
              tmpApproverDataArray.push(new ApproverFormData(userTmp.users[0].username, userTmp.users[0].uidNumber, userTmp.deputyUsers[0]?.username, userTmp.deputyUsers[0]?.uidNumber, userTmp.limit ?? undefined, undefined, undefined, userTmp.forInformationOnly));
            }
            break;
          case ApproverType.APPROVER_GROUP: {
            // Alle Gruppenmitglieder aufnehmen
            const tmpApproverDataGroupMember: ApproverFormData[] = [];
            for (const approvalGroupMember of userTmp.groupMembers) {
              tmpApproverDataGroupMember.push(new ApproverFormData(approvalGroupMember.username, approvalGroupMember.uidNumber, undefined, undefined, undefined, undefined, undefined, undefined));
            }

            // Mitglieder in eine Gruppe schmeißen
            const tmpApproverDataGroup = new ApproverFormData(undefined, undefined, undefined, undefined, userTmp.forInformationOnly ? (userTmp.limit ?? undefined) : undefined, tmpApproverDataGroupMember, userTmp.mailNotification, userTmp.forInformationOnly);
            tmpApproverDataArray.push(tmpApproverDataGroup);
            break;
          }
          default: {
            const tmpApproverDataGroup = new ApproverFormData(undefined, undefined, undefined, undefined, userTmp.forInformationOnly ? (userTmp.limit ?? undefined) : undefined, undefined, undefined, userTmp.forInformationOnly);
            tmpApproverDataArray.push(tmpApproverDataGroup);
          }
        }
        i++;
      }
    }
    this.approverData = JSON.stringify(tmpApproverDataArray);
    this.orderedApprovals = form.orderedApprovals;
    this.orgUnitType = form.orgUnitType;
    this.orgUnitName = form.orgUnitName?.trim();
    this.privacyReason = form.privacyReason?.trim();
    this.dataFields = JSON.stringify(form.dataFieldsCustomParameter?.filter(s => s).map(s => s.trim()) ?? []);
    this.legalBasis = form.legalBasis?.trim();
    this.dataTransmission = form.dataTransmission?.trim();
    this.externalDataTransmission = form.externalDataTransmission?.trim();
    this.storagePeriod = form.storagePeriod;
    this.contactEmail = form.contactEmail?.trim();
    this.contactTelephone = form.contactTelephone?.trim();
  }
}
